/**
 * *************************************
 *  SHADAPPS CONFIDENTIAL
 *  __________________
 *
 *  Created by Vittorio Tauro
 *
 *  2022 (c) ShadApps Srl
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of ShadApps Srl and its suppliers,
 *  if any. The intellectual and technical concepts contained
 *  herein are proprietary to ShadApps Srl.
 *  and its suppliers and may be covered by Italian, European and Foreign Patents,
 *  patents in process, and are protected by trade secret or copyright law.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from ShadApps Srl.
 * *************************************
 * */

import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

import project from '../../json/project/projectJson';

// ----------------------------------------------------------------------

LogoSquare.propTypes = {
    disabledLink: PropTypes.bool,
    sx: PropTypes.object,
};

export default function LogoSquare({ disabledLink = false, sx }) {
    const theme = useTheme();

    const PRIMARY_LIGHT = theme.palette.primary.light;

    const PRIMARY_MAIN = theme.palette.primary.main;

    const PRIMARY_DARK = theme.palette.primary.dark;

    // OR
    const logoUrl = project.logoSquare;
    // return null;
    const logo = (
        <Box sx={{ width: 40, height: 40, ...sx }}>
            <img src={logoUrl} alt={`logo ${project.logo}`} />
        </Box>
    );

    if (disabledLink) {
        return <>{logo}</>;
    }

    return (
        <RouterLink
            style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '10px',
            }}
            to="/"
        >
            {logo}
        </RouterLink>
    );
}
